import { render } from "./TelegramCommentModeration.vue?vue&type=template&id=58440eee&scoped=true"
import script from "./TelegramCommentModeration.vue?vue&type=script&lang=js"
export * from "./TelegramCommentModeration.vue?vue&type=script&lang=js"

import "./css/style.css?vue&type=style&index=0&id=58440eee&scoped=true&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58440eee"]])

export default __exports__